<template>
  <div class="account" v-if="auth.user">
    <div class="row justify-content-md-center" style="margin-top:10px;">
      <div class="col-lg-6 col-12">
        <b-jumbotron class="text-dark">
          <template slot="header">
            <b-img v-if="auth.user.photoURL" :src="auth.user.photoURL" width="64"></b-img>
            {{ auth.user.name }}
          </template>

          <template slot="lead">
            {{ auth.user.email }}
          </template>

          <hr class="my-4">

          <p v-if="auth.user.subscription.active">
            Vous disposez d'un abonnement VIP.<br/>
            Le prochain paiement est prévu le <b>{{ moment(auth.user.subscription.expires_at).format('dddd Do MMMM YYYY') }}</b>
          </p>
          <p v-if="!auth.user.subscription.active">
            <span v-if="auth.user.subscribed">
              Votre abonnement VIP expire le <b>{{ moment(auth.user.subscription.expires_at).format('dddd Do MMMM YYYY') }}</b>
            </span>
            <span v-else-if="auth.user.subscription.expires_at > 0">
              Votre abonnement a expiré le {{ moment(auth.user.subscription.expires_at).format('dddd Do MMMM YYYY') }}
            </span>
            <span v-else>
              Vous ne disposez pas d'abonnement VIP
            </span>
          </p>

          <b-button v-if="auth.user.subscription.active" :href="paypal.url + '?cmd=_subscr-find&alias=' + paypal.unsubscribe_id" target="_blank" variant="dark">Se désabonner</b-button>
          <b-button v-if="!auth.user.subscription.active" to="/abonnement" variant="dark">S'abonner</b-button>

          <hr class="my-4">

          <div v-if="auth.user.subscribed && userData">
            <h4>Mes alertes</h4>
            <b-alert :show="alert.message" :variant="alert.variant">{{ alert.message }}</b-alert>
            <b-form @submit="onSubmit">
              <b-form-group id="input-group-email" label="Email:" label-for="input-email">
                <b-form-input
                  id="input-email"
                  v-model="userData.email"
                  type="email"
                  placeholder="Adresse Email"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-type" label="Type" label-for="input-type">
                <b-form-checkbox-group id="checkbox-group-type" v-model="userData.notifications" switches stacked >
                  <b-form-checkbox value="football">Football</b-form-checkbox>
                  <b-form-checkbox value="tennis">Tennis</b-form-checkbox>
                  <b-form-checkbox value="basket">Basket</b-form-checkbox>
                  <b-form-checkbox value="multisports">Multisports</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>

              <b-button type="submit" variant="dark">Enregistrer</b-button>
            </b-form>
          </div>
        </b-jumbotron>
        <small class="float-right text-muted">Mon identifiant: {{ auth.user.uid }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { auth, db } from '@/firebase.js'
import paypal from '@/paypal.js'

export default {
  data: () => ({ auth: auth, userData: null, paypal: paypal, alert: { variant: 'success', message: null } }),
  methods: {
    moment(ts) { return moment.unix(ts) },
    onSubmit(evt) {
      evt.preventDefault()
      db.collection('users').doc(auth.user.uid).set(this.userData).then(() => {
        this.alert.message = 'Notifications mise à jour !'
      }).catch((error) => {
        this.alert.variant = 'danger'
        this.alert.message = error.message
      })
    }
  },
  watch: {
    auth: {
      immediate: true,
      handler(auth) {
        if(auth.user) {
          this.$bind('userData', db.collection('users').doc(auth.user.uid))
        }
      },
    },
  }
}
</script>